var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.value),function(item,index){return _c('div',{key:index},[_c('asc-label',{attrs:{"value":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }